/**
 * Motif d'une écriture refusée, TRADUIT — l'unique endroit où le français de `motifEcritureRefusee`
 * (`auth/session`) devient une phrase de la langue de l'interface (N-30 (a), audit d'utilisabilité du
 * 2026-10-09).
 *
 * `motifEcritureRefusee` est rédigé en français. Quatre écrans l'affichaient tel quel — le dialogue
 * « Nouveau projet » (deux emplacements), la carte « Charte, sans jargon » et le dossier de décision —,
 * si bien que l'interface anglaise disait « Administrateur de plateforme : … » ; seul le menu « Créer »
 * le traduisait, par un `t()` écrit chez lui. Le crochet porte cette traduction (clés
 * `ecriture.refus.administrateurPlateforme` et `ecriture.refus.lectureSeule`) pour tous.
 *
 * DEUX SESSIONS, DEUX QUESTIONS (N-41) :
 *  - `session` : celle dont on juge l'écriture — le jeton (`useSession`), ou le rôle EFFECTIF du projet
 *    ouvert (`useEffectiveSession`) ;
 *  - `jeton` : celle dont les rôles de REALM disent POURQUOI elle n'écrit pas. « Administrateur de
 *    plateforme : ce compte n'écrit pas dans les projets » décrit un JETON sans rôle d'écriture. Un jeton
 *    qui écrit mais dont l'appartenance au projet est « lecteur » est en lecture seule dans CE projet,
 *    même s'il porte aussi `admin` (les rôles effectifs gardent `admin`) : le libellé « administrateur »
 *    y contredisait un « Nouveau projet » actif. Par défaut, la session jugée est aussi celle qui explique.
 */
import { motifEcritureRefusee, type Session } from '@/auth/session'
import { useT } from '@/i18n/language'

export function useMotifEcritureRefusee(session: Session | null, jeton: Session | null = session): string | null {
  const { t } = useT()
  if (session === null || motifEcritureRefusee(session) === null) return null
  const administrateur = motifEcritureRefusee(jeton) !== null && Boolean(jeton?.roles.includes('admin'))
  // Le repli français est le motif d'un compte qui n'aurait QUE cette cause : jamais celui d'une autre
  // (la clé et le repli disent la même chose, même si le catalogue ne portait pas la clé).
  const repli = motifEcritureRefusee({ ...session, roles: [administrateur ? 'admin' : 'workspace_viewer'] }) ?? ''
  return t(administrateur ? 'ecriture.refus.administrateurPlateforme' : 'ecriture.refus.lectureSeule', repli)
}
